export default __webpack_public_path__ + "static/media/contactMap.1619e2a2.jpg";